import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import type { SyncedBlockPlugin } from '@atlaskit/editor-plugin-synced-block';

import { expValEquals } from '@confluence/feature-experiments';

export type EditorPresetAPI = PublicPluginAPI<[SyncedBlockPlugin]> | null | undefined;

export const useSharedSyncBlockState = conditionalHooksFactory(
	() => expValEquals('platform_synced_block', 'isEnabled', true),
	(api: EditorPresetAPI) => {
		const hasUnsavedBodiedSyncBlockChanges =
			(useSharedPluginStateSelector(api, 'syncedBlock.hasUnsavedBodiedSyncBlockChanges' as never, {
				disabled: !api,
			}) as boolean | undefined) ?? false;
		return { hasUnsavedBodiedSyncBlockChanges };
	},
	(_api: EditorPresetAPI) => {
		return {
			hasUnsavedBodiedSyncBlockChanges: false,
		};
	},
);
